export default __webpack_public_path__ + "static/RTG_PDP_LOGO_KINGSDOWN_960x100-f0619f1b06f4c3c3341a52680226021e.png";